function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#likeicon .cls-1{fill:#1496ee;} #likeicon.cls-2{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M27.66,13.83A13.83,13.83,0,1,1,13.83,0,13.83,13.83,0,0,1,27.66,13.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M9,11.08H6.28a1.14,1.14,0,0,0-1.14,1.14v7.23a1.14,1.14,0,0,0,1.14,1.14H9a1.14,1.14,0,0,0,1.14-1.14V12.22A1.14,1.14,0,0,0,9,11.08Zm-.35,8.83a.66.66,0,1,1,.65-.65A.65.65,0,0,1,8.65,19.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M20.82,16.07v.06H21a1.18,1.18,0,0,1,.84,2,1.19,1.19,0,0,1-.84.35h-.21v.06a1,1,0,0,1,0,2h-7.9a1.68,1.68,0,0,1-1.68-1.68V12.52c0-1,1.29-3.09,2.11-4A1.94,1.94,0,0,0,13.87,7c-.07-.88,0-2.14.88-2.22,1.4-.13,2.55,2.29,1.89,4.12-.28.74-.5,1.28-.68,1.66h5.11a1.46,1.46,0,0,1,1,2.48,1.41,1.41,0,0,1-.91.42,1.31,1.31,0,0,1,.89,2.23,1.35,1.35,0,0,1-.93.38Z"
})));

var SvgLike = function SvgLike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "likeicon",
    viewBox: "0 0 27.66 27.66",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/like.6d00350e.svg";
export { ForwardRef as ReactComponent };